export default __webpack_public_path__ + "static/media/expert_login.1fd2e2bc.svg";